module.exports = __webpack_public_path__ + "assets/img/picture1.29769f28.png";